module.exports = __webpack_public_path__ + "static/media/icon-entertainment.89b3c53b.svg";